import { Component, OnInit, AfterViewInit, ViewEncapsulation, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { ManageInventoryService } from '../../manage-inventory/shared/providers/manage-inventory.service';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { SignupSetupInputModel, SignupSetupOutputModel, FanModel, EnrollmentDateModel } from '../../signup-setup/shared/models/signup-setup.models';
// import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { SIGNUPSETUPDATA } from 'config';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { MOBILEPIVOTS, TERMSCONDITIONS } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { SignupSetupService } from '../shared/providers/signup-setup.service';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';

@Component({
  selector: 'app-reviewpoc',
  templateUrl: './reviewpoc.component.html',
  styleUrls: ['./reviewpoc.component.scss'],  
  providers: [SignupSetupService, ManageInventoryService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})
export class ReviewpocComponent implements OnInit {

  signupArray:[];
  isDisabled: boolean = true;


  constructor(private router: Router,
    private pageloaderService: PageLoaderService,
    private activatedRoute: ActivatedRoute,
    private signupSetupService: SignupSetupService,
    private manageInventoryService: ManageInventoryService,
    private utilityService: UtilityService,
    private stepindicatorService: StepIndicatorService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private breadCrumbService: BreadCrumbService,
    private pageLoaderService: PageLoaderService) { 

    this.signupArray = [];
  }

  ngOnInit() {

    this.breadCrumbService.removeLastBreadCrumb();
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device Enrollment Program', routerLink: '/signupsetup/enrollmentoptions' });

    this.stepindicatorService.setCurrentStep('review');
    this.stepindicatorService.setVisibility(true);

    this.signupArray = JSON.parse(sessionStorage.getItem('enrollArraypoc'));

  }

  enableSubmit() {
        this.isDisabled = !this.isDisabled;

}

}
